let locales = {
    cronConfig_announcement: 'Cron campañas',
    cronConfig_interval: 'Intervalo de ejecución en milisegundos (mínimo 60000)',
};
export default locales;